import { FormControl, Autocomplete, TextField } from "@mui/material";
import _ from "lodash";

export function FormDetailsSelect({ item, errors, handleSelect }) {
  return (
    <FormControl required fullWidth>
      <Autocomplete
        id={`grouped-${item.id}-autocomplete`}
        onChange={(e, newValue) => handleSelect(`${item.id}Select`, newValue)}
        options={item.options}
        fullWidth
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label={_.startCase(item.id)}
            error={errors && errors[item.id] && true}
            helperText={errors && errors[item.id] !== "" ? errors[item.id] : ""}
          />
        )}
      />
    </FormControl>
  );
}
